import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { useStyleConfig } from '../abstract';
import { VcCheckbox } from '../vc-checkbox';
import { defineComponent, resolveComponent, openBlock, createBlock, withCtx, createElementVNode, normalizeClass, mergeProps, withDirectives, createVNode, vShow } from 'vue';
import { CheckOutlined } from '@ant-design/icons-vue';
import { Tooltip } from 'ant-design-vue';
var _sfc_main = defineComponent({
  name: 'ImgCheckbox',
  components: {
    CheckOutlined: CheckOutlined,
    ATooltip: Tooltip
  },
  mixins: [VcCheckbox],
  props: {
    src: String,
    title: String,
    width: {
      type: Number,
      default: 52
    },
    height: {
      type: Number
    }
  },
  setup: function setup() {
    var _useStyleConfig = useStyleConfig('img-checkbox'),
      prefixCls = _useStyleConfig.prefixCls;
    return {
      prefixCls: prefixCls
    };
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var _hoisted_1 = ["width", "src"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CheckOutlined = resolveComponent("CheckOutlined");
  var _component_a_tooltip = resolveComponent("a-tooltip");
  return openBlock(), createBlock(_component_a_tooltip, {
    title: _ctx.title
  }, {
    default: withCtx(function () {
      return [createElementVNode("div", {
        class: normalizeClass(_ctx.prefixCls),
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.toggle && _ctx.toggle.apply(_ctx, arguments);
        })
      }, [createElementVNode("img", mergeProps({
        width: _ctx.width
      }, _ctx.height ? {
        height: _ctx.height
      } : {}, {
        class: "".concat(_ctx.prefixCls, "-img"),
        src: _ctx.src
      }), null, 16, _hoisted_1), withDirectives(createVNode(_component_CheckOutlined, {
        class: normalizeClass("".concat(_ctx.prefixCls, "-check-icon"))
      }, null, 8, ["class"]), [[vShow, _ctx.bindChecked]])], 2
      /* CLASS */)];
    }),

    _: 1
    /* STABLE */
  }, 8, ["title"]);
}
var ImgCheckbox = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/img-checkbox/ImgCheckbox.js"]]);
export { ImgCheckbox as default };